var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelled = function SvgCancelled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.53 5.47 10 8.94l3.47-3.47 1.06 1.06L11.06 10l3.47 3.47-1.06 1.06L10 11.06l-3.47 3.47-1.06-1.06L8.94 10 5.47 6.53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10m-1.5 0a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0",
    clipRule: "evenodd"
  })));
};
export { SvgCancelled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNNi41MyA1LjQ3TDEwIDguOTRsMy40Ny0zLjQ3IDEuMDYgMS4wNkwxMS4wNiAxMGwzLjQ3IDMuNDctMS4wNiAxLjA2TDEwIDExLjA2bC0zLjQ3IDMuNDctMS4wNi0xLjA2TDguOTQgMTAgNS40NyA2LjUzbDEuMDYtMS4wNnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjAgMTBjMCA1LjUyMy00LjQ3NyAxMC0xMCAxMFMwIDE1LjUyMyAwIDEwIDQuNDc3IDAgMTAgMHMxMCA0LjQ3NyAxMCAxMHptLTEuNSAwYTguNSA4LjUgMCAxMS0xNyAwIDguNSA4LjUgMCAwMTE3IDB6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";